import React from 'react';
import {Drawer, DrawerOverlayProps} from '@mantine/core';

export const EtroDrawerOverlay: React.FC<DrawerOverlayProps> = props => {
  return <Drawer.Overlay {...props} />;
};
